import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { AuthProvider } from 'react-oidc-context';

import App from './App';
import Main from './Main';
import 'helpers/initFA';
import store from 'reducers/store';
import { oidcSettings } from './config';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AuthProvider {...oidcSettings}>
      <Provider store={store}>
        <Main>
          <App />
        </Main>
      </Provider>
    </AuthProvider>
  </React.StrictMode>
);
